// import crawlerAPI from "@/api/crawler/crawler.js";
import { FETCH } from "@/utils/list.js";

export default {
  state: {
    logs: [],
    limit : 10,
    offset: 0,
  },
  mutations: {
    LOGGER_CACHE_LOG(state, list) {
      state.logs = list;
      let comparer = (obj, item) => {
        return obj.id === item.id;
      };
      FETCH(state.logs, list, comparer, null);
    },
  },
  actions: {
    async fetchLogs(store, data) {
      let state = store.state;
      
      await crawlerAPI
        .getLogs(data, state.limit, state.offset)
        .then(res => {
          if (res) {
            if (!state.fetched) {
              state.fetched = true;
            }

            store.commit("LOGGER_FETCH_ACTIVITIES", res.data.object);
            return res.data.object;
          } else {
            console.warn(res.data.message);
          }
          state.loading = false;
        })
        .catch(err => {
          state.loading = false;
          // store.commit("OpenError", {message: err})
          if (!state.fetched) {
            // store.commit("CloseLoading");
          }
        })

    },
  }
};
